<template>
    <aside class="pf-sidebar">
        <div class="pf-head">
            <span class="pf-head-lbl">FILTROS AVANZADOS</span>
            <button v-if="hasChanges" class="pf-clear" type="button" @click.prevent="resetFilters()">LIMPIAR</button>
        </div>

        <div class="pf-search">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                <circle cx="6" cy="6" r="4.5" stroke="currentColor" stroke-width="1.4"/>
                <path d="M9.5 9.5 L 12 12" stroke="currentColor" stroke-width="1.4"/>
            </svg>
            <input type="text" v-model="filters.search_filter" placeholder="Buscar producto" />
        </div>

        <div class="pf-field" v-if="config.categories && config.categories.length > 0">
            <span class="pf-field-lbl">APLICACIÓN</span>
            <select v-model="filters.categories" class="pf-select">
                <option :value="null">Todas las aplicaciones</option>
                <option v-for="(category, index) in config.categories" :value="category" :key="index">{{ category }}</option>
            </select>
        </div>

        <div class="pf-field" v-if="config.bases && config.bases.length > 0">
            <span class="pf-field-lbl">BASE</span>
            <select v-model="filters.bases" class="pf-select">
                <option :value="null">Todas las bases</option>
                <option v-for="(base, index) in config.bases" :value="base" :key="index">{{ base }}</option>
            </select>
        </div>

        <div class="pf-field" v-if="config.isos && config.isos.length > 0">
            <span class="pf-field-lbl">ESPECIFICACIÓN</span>
            <select v-model="filters.isos" class="pf-select">
                <option :value="null">Todas las especificaciones</option>
                <option v-for="(iso, index) in config.isos" :value="iso" :key="index">{{ iso }}</option>
            </select>
        </div>

        <div class="pf-field" v-if="config.brands && config.brands.length > 0">
            <span class="pf-field-lbl">MARCA</span>
            <select v-model="filters.brand" class="pf-select">
                <option :value="null">Todas las marcas</option>
                <option v-for="(brand, index) in config.brands" :value="brand._id" :key="index">{{ brand.name }}</option>
            </select>
        </div>

        <div class="pf-footer">{{ activeCount }} {{ activeCount === 1 ? 'filtro activo' : 'filtros activos' }}</div>
    </aside>
</template>
<script>
import _ from 'lodash';
import filters_mixins from '../mixins/filters_mixin.js';

export default {
    mixins: [filters_mixins],
    props: {
        config: {
            type: Object
        }
    },
    data() {
        return {
            filters: {
                search_filter: "",
                page_size: 9,
                categories: null,
                isos: null,
                bases: null,
                brand: null,
                page: 1,
            },
            defaultFilters: {
                search_filter: "",
                page_size: 9,
                categories: null,
                isos: null,
                bases: null,
                brand: null,
                page: 1,
            },
            pageSizeOptions: [9, 12, 24, 48],
            defaultPrices: [0, 1000, 2500, 5000, 10000, 25000, 50000, 100000]
        }
    },
    computed: {
        activeCount() {
            let count = 0;
            if (this.filters.search_filter) count++;
            if (this.filters.categories) count++;
            if (this.filters.bases) count++;
            if (this.filters.isos) count++;
            if (this.filters.brand) count++;
            return count;
        }
    },
    watch: {
        filters: {
            handler: _.debounce(function (newItem) {
                this.refresh();
            }, 1000),
            immediate: true,
            deep: true
        },
        'filters.search_filter': {
            handler: function (newItem) {
                if (newItem) {
                    this.filters.categories = null;
                    this.filters.isos = null;
                    this.filters.bases = null;
                    this.filters.brand = null;
                }
                this.$emit('resetPage');
            },
            immediate: true,
        },
        'filters.isos': {
            handler: function (newItem) {
                this.$emit('resetPage');
            },
        },
        'filters.bases': {
            handler: function (newItem) {
                this.$emit('resetPage');
            },
        },
        'filters.categories': {
            handler: function (newItem) {
                this.$emit('resetPage');
            },
        },
        'filters.brand': {
            handler: function (newItem) {
                this.$emit('resetPage');
            },
        },
        config: {
            handler: function (newItem) {
                if (newItem) this.getFiltersParamsFromUrl();
            },
            immediate: true,
        },
    },
    methods: {
        refresh() {
            this.$emit("refresh", this.filters);
        }
    }
}
</script>
